// 右侧面板 tabs 的 key
export const RIGHT_PANEL_TAB_KEY_VARIABLE_LIST = 'variableList'
export const RIGHT_PANEL_TAB_KEY_VARIABLE_CONFIGURE = 'variableConfigure'
